"use client";

import type { RefObject } from "react";
import { useTranslations } from "use-intl";

import { FilterSettingsIcon } from "@/components/appIcons";

export function MobileFilterButton({
  hidden,
  activeFilterCount,
  onOpen,
  buttonRef,
}: {
  hidden: boolean;
  activeFilterCount: number;
  onOpen: () => void;
  buttonRef: RefObject<HTMLButtonElement | null>;
}) {
  const t = useTranslations("globals.search");
  return (
    <div
      className={`fixed bottom-16 left-0 right-0 z-40 px-4 pb-2 md:hidden ${hidden ? "invisible" : ""}`}
    >
      <button
        ref={buttonRef}
        type="button"
        aria-label={t("filters")}
        aria-controls="search-filters"
        aria-expanded={hidden}
        onClick={onOpen}
        className="w-full flex items-center justify-center gap-2 py-3 bg-primary text-primary-foreground font-bold rounded-lg shadow-lg shadow-primary/20"
      >
        <FilterSettingsIcon className="text-lg" />
        {t("filters")}
        {activeFilterCount > 0 && (
          <span className="inline-flex items-center justify-center h-5 min-w-5 px-1 bg-primary-foreground text-primary text-xs font-bold rounded-full">
            {activeFilterCount}
          </span>
        )}
      </button>
    </div>
  );
}
